/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Marker } from './Marker';
import { LineStyle, MarkerShapes } from './Shapes.types';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { Line } from './Line';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';

type SymbolProps = {
  markerShape: MarkerShapes | 'none';
  lineStyle: LineStyle | 'none';
  lineWidth?: number;
  lineColor?: ColorProps['color'];
  borderColor?: ColorProps['color'];
  markerColor?: ColorProps['color'];
  setAspectRatioNone?: boolean;
};

const MARKER_SHAPE_RATIO = 0.65;
const MAX_SCALE = 0.95; // Reduce scale so that stroke is not clipped.
export const SvgSymbol = ({
  markerShape,
  lineStyle = 'none',
  lineWidth,
  lineColor,
  borderColor,
  markerColor,
  setAspectRatioNone
}: SymbolProps) => {
  const markerScale = lineStyle != 'none' ? MARKER_SHAPE_RATIO : MAX_SCALE;
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      class={style.base}
      preserveAspectRatio={setAspectRatioNone ? 'none' : undefined}>
      {lineStyle != 'none' && (
        <Line lineStyle={lineStyle} lineWidth={lineWidth} color={lineColor} />
      )}

      {markerShape != 'none' && (
        <Marker
          type={markerShape}
          scale={markerScale}
          height={100}
          width={100}
          preserveRectAspectRatio={!setAspectRatioNone}
          fill={markerColor}
          stroke={borderColor}
        />
      )}
    </svg>
  );
};

const style = {
  base: cssProps`${{
    position: 'absolute'
  }}`
};
